import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { Redirect, useParams, useHistory } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Alert } from '@mui/material';

import { useChapterRequestQuery } from 'generated/graphql';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import { BackButton } from 'components/BackButton/BackButton';

import ChapterRequestForm from './ChapterRequestForm';
import { RejectChapterRequestModal } from './RejectChapterRequestModal';

interface RouteParams {
  id: string;
}

const ChapterRequestReviewPage = () => {
  const organization = useSelector(selectOrganization);
  const user = useSelector(selectUser);
  const history = useHistory();
  const [rejectionModalOpen, setRejectionModalOpen] = useState(false);

  const { id } = useParams<RouteParams>();

  const { data, loading, error } = useChapterRequestQuery({
    variables: {
      id,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  if (!organization || !user || loading) {
    return <LinearProgress />;
  }

  if (!user.isAdmin) {
    return <Redirect to="/404" />;
  }

  return (
    <>
      <Helmet title="Review chapter request" />

      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <BackButton onClick={() => history.goBack()} />
      </div>

      {data?.chapterRequest && (
        <ChapterRequestForm
          chapterRequest={data.chapterRequest}
          onReject={() => setRejectionModalOpen(true)}
        />
      )}

      {error && <Alert security="error">There was an error loading the data</Alert>}

      {data?.chapterRequest && (
        <RejectChapterRequestModal
          id={data.chapterRequest.id}
          open={rejectionModalOpen}
          onClose={() => {
            setRejectionModalOpen(false);
            history.goBack();
          }}
        />
      )}
    </>
  );
};

export default ChapterRequestReviewPage;
